/**
 * 联和办公
 * Created by lly on 2018/10/11 0001.
 */

export default [{
    path: '/uniteWork',
    component: () => import('../components/uniteWork/index.vue')
}]